import {
  Sb_CreateUniversalShoppingBasketMutation,
  Sb_CreateUniversalShoppingBasketMutationVariables,
} from '#src/generated/graphql';
import { useMutation } from '@edreamsodigeo/frontend-api-client';
import { useFrontendApiBlockingError } from '@edreamsodigeo/frontend-core';
import { useMemo } from 'react';

import { CREATE_UNIVERSAL_SHOPPING_BASKET } from './operations/ShoppingBasketProvider.mutations';

export const useCreateShoppingBasket = () => {
  const createShoppingBasketResponse = useMutation<
    Sb_CreateUniversalShoppingBasketMutation,
    Sb_CreateUniversalShoppingBasketMutationVariables
  >(CREATE_UNIVERSAL_SHOPPING_BASKET);

  useFrontendApiBlockingError(createShoppingBasketResponse);

  const { errors, mutate, loading, data } = createShoppingBasketResponse;

  const shoppingBasketId = useMemo(
    () => data?.createUniversalShoppingBasket?.shoppingBasketId,
    [data]
  );

  const shoppingBasketToken = useMemo(
    () => data?.createUniversalShoppingBasket?.shoppingBasketToken?.token,
    [data]
  );

  return {
    errors,
    loading,
    shoppingBasketId,
    shoppingBasketToken,
    createShoppingBasket: () => {
      mutate({});
    },
  };
};
